(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jr-cart-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jr-cart-promo')){customElements.define('jr-cart-promo',class extends HTMLElement{connectedCallback(){const start=Number(this.dataset.start)*1000;const end=Number(this.dataset.end)*1000;const update=()=>{const now=Date.now();this.hidden=!Number.isFinite(start)||!Number.isFinite(end)||now<start||now>=end;if(this.hidden)clearInterval(this.expiryTimer)};this.expiryTimer=setInterval(update,1000);update();this.checkExpiry=update;document.addEventListener('visibilitychange',update)}disconnectedCallback(){clearInterval(this.expiryTimer);document.removeEventListener('visibilitychange',this.checkExpiry)}})}
  } catch(e) { console.error(e); }
})();

})();
